import { Check, Timer, TimerOff } from 'lucide-react';
import type { DisappearingDuration } from '@twinden/shared';
import { ChatSheet } from './ChatSheet';
import { DISAPPEARING_CHOICES, durationOf } from '../../lib/disappearing';
import { useT } from '../../i18n';

// Header ⋯ → Disappearing messages (M64, D238): Off, 24 hours, 7 days,
// 90 days, for everyone in the chat. The current one is ticked.
export function DisappearingSheet({
  isOpen,
  seconds,
  onPick,
  onClose,
}: {
  isOpen: boolean;
  seconds: number | null | undefined;
  onPick: (duration: DisappearingDuration) => void;
  onClose: () => void;
}) {
  const t = useT();
  const current = durationOf(seconds);
  const label = (choice: DisappearingDuration) =>
    choice === 'off'
      ? t('chat.disappearing.off')
      : t(`chat.disappearing.${choice}`);
  return (
    <ChatSheet
      isOpen={isOpen}
      title={t('chat.disappearing.title')}
      body={t('chat.disappearing.body')}
      label={t('chat.disappearing.title')}
      onClose={onClose}
      rows={DISAPPEARING_CHOICES.map((choice) => ({
        key: choice,
        label: label(choice),
        icon:
          choice === current ? (
            <Check size={20} />
          ) : choice === 'off' ? (
            <TimerOff size={20} />
          ) : (
            <Timer size={20} />
          ),
        detail: choice === current ? t('chat.disappearing.current') : undefined,
        onSelect: () => {
          if (choice !== current) onPick(choice);
        },
      }))}
    />
  );
}
